<template>
	<NuxtLink
		:to="to"
		class="block group transition-all duration-150 h-full"
	>
		<div
			:class="[
				'py-4 lg:py-5 flex flex-col h-full transition-all duration-150',
				featured ? 'overflow-hidden p-0' : ''
			]"
		>
			<img
				v-if="image && featured"
				:src="image"
				alt="Featured"
				class="w-full object-cover rounded-2xl aspect-[16/9] mb-4"
				loading="lazy"
				width="290"
				height="164"
			/>
			<div class="pt-0 px-0">
				<h4
					class="hover:underline"
					:class="[
						featured ? 'font-semibold text-lg mb-1' : 'font-bold text-base mb-1',
						'text-slate-900'
					]"
				>
					{{ title }}
				</h4>
				<div class="text-slate-600 text-sm mb-2 line-clamp-4">
					{{ description }}
				</div>
				<ClientOnly>
					<div
						v-if="ticker"
						class="flex gap-2 mt-auto"
					>
						<TickerBadge
							:key="ticker.SYMBOL"
							:symbol="ticker.SYMBOL"
							:change="String(ticker.PC_CHG?.toFixed(2) || '0') + '%'"
						/>
					</div>
				</ClientOnly>
			</div>
		</div>
	</NuxtLink>
</template>
<script setup>
import { computed, defineProps } from "vue";
import TickerBadge from "./TickerBadge.vue";
import { useStocksStore } from "~/stores/useStocksStore";

const stocksStore = useStocksStore();

const props = defineProps({
	image: String,
	title: String,
	description: String,
	stock_pairs: Array,
	to: String,
	featured: Boolean
});

// Get stock data from subscriptions using stock_pairs[1]
const ticker = computed(() => {
	if (!props.stock_pairs || !props.stock_pairs[1]) {
		return null;
	}

	return stocksStore.getStockSubscription(props.stock_pairs[1]);
});
</script>
